<template>
  <div ref="scrollContainer" class="scrollContainer" :class="{scrolling: scrolling}" @wheel="scrollByWheel" v-resize="onResize">
    <div ref="scrollbar" class="scrollbar" v-show="show">
      <!-- <button type="button" class="icon-button up" @click="up" v-show="useUpDown"></button> -->
      <div class="scroll-area" @click="onScrollAreaClick">
        <button type="button" class="icon-button scroll" :style="{ height: scrollHeight + 'px', top: scrollTop + 'px' }" @mouseup="onMouseUp($event)" @mousedown="onMouseDown($event)"></button>
      </div>
      <!-- <button type="button" class="icon-button down" @click="down" v-show="useUpDown"></button> -->
    </div>
    <div ref="scrollContent" class="scroll-content" v-resize="contentOnResize" :style="{ top: scrollContetnTop + 'px' }">
      <slot>
      </slot>
    </div>
    <slot name="absolute"></slot>
  </div>
</template>
<script>
import resize from 'vue-resize-directive'
const maxTop = 0
const upAndDownHeight = (12 * 2)
export default {
  name: 'scrollbar',
  components: {
  },
  directives: {
    resize
  },
  props: {
    fill: Boolean,
    useUpDown: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      show: false,
      canUseHeight: 0,
      moveRange: 0,
      overHeight: 0,
      moveStep: 0,
      top: 0,
      topPercentage: 0,
      scrollHeight: 0,
      scrolling: false,
      scrollLastY: 0,
      delayScrollToElement: {},
      mouseMoveRange: 10
    }
  },
  mounted: function () {
    this.$refs.scrollContainer.addEventListener('mousemove', this.handleMouseMove)
    document.getElementById('app').addEventListener('mouseup', this.handleMouseUp)
    // this.$refs.scrollContainer.addEventListener('mouseup', this.handleMouseUp)
    this.calculate()
    // emit topChanged after calculate for UI initial detection
    this.$emit('topChanged')
  },
  beforeDestroy: function () {
    this.$refs.scrollContainer.removeEventListener('mousemove', this.handleMouseMove)
    document.getElementById('app').removeEventListener('mouseup', this.handleMouseUp)
    // this.$refs.scrollContainer.removeEventListener('mouseup', this.handleMouseUp)
  },
  methods: {
    onResize () {
      this.calculate()
    },
    contentOnResize (el) {
      if (this.$refs.scrollContainer) {
        this.calculate()
      }
    },
    handleMouseMove: function (event) {
      if (this.scrolling) {
        const mouseMoveRange = event.clientY - this.scrollLastY
        this.scrollLastY = event.clientY
        this.scroll(-mouseMoveRange)
      }
      event.preventDefault()
      event.stopPropagation()
    },
    handleMouseUp: function (event) {
      this.scrolling = false
      // event.preventDefault()
    },
    onMouseDown: function (event) {
      this.scrolling = true
      this.scrollLastY = event.clientY
      // event.preventDefault()
    },
    onMouseUp: function (event) {
      this.scrolling = false
      // event.preventDefault()
    },
    up: function () {
      this.scroll(this.mouseMoveRange)
    },
    down: function () {
      this.scroll(-this.mouseMoveRange)
    },
    onScrollAreaClick: function (event) {
      if (event.target.className === 'icon-button scroll') {
        return
      }
      const scrollTop = parseInt(this.$refs.scroll.$el.style.top.replace('px', ''))
      const scrollHeight = parseInt(this.$refs.scroll.$el.style.height.replace('px', ''))
      if (event.layerY < scrollTop) {
        this.top = -event.layerY
      } else {
        this.top = -(event.layerY - scrollHeight)
      }
      // event.preventDefault()
    },
    calculate: function () {
      const contentHeight = this.$refs.scrollContent ? this.$refs.scrollContent.offsetHeight : 0
      this.canUseHeight = this.$refs.scrollContent ? this.$refs.scrollContainer.offsetHeight : 0
      this.overHeight = contentHeight - this.canUseHeight
      if (this.canUseHeight !== 0 && this.overHeight > 0 && !this.fill) {
        this.show = true
        const scrollFreeHeight = this.canUseHeight - ((this.useUpDown) ? upAndDownHeight : 0)
        this.scrollHeight = scrollFreeHeight * (scrollFreeHeight / contentHeight)
        this.scrollHeight = (this.scrollHeight < 20) ? 20 : this.scrollHeight
        this.moveRange = scrollFreeHeight - this.scrollHeight + 24
        this.moveStep = this.overHeight / this.moveRange
        if (this.overHeight > 0) {
          if (this.delayScrollToElement && this.delayScrollToElement.offsetTop) {
            this.scrollTo(this.delayScrollToElement)
            this.delayScrollToElement = {}
          } else {
            // let scrollbar top keep on the same position
            this.top = this.moveRange * this.topPercentage
          }
        }
      } else {
        this.top = 0
        this.show = false
      }
    },
    delayScrollTo: function (element) {
      this.delayScrollToElement = element
    },
    scrollTo: function (element) {
      if (!this.show) return
      const contentHeight = this.$refs.scrollContent.offsetHeight
      let newTop = element.offsetTop
      // check whether the newTop exceed the content height
      if (newTop + this.canUseHeight > contentHeight) {
        newTop = contentHeight - this.canUseHeight
      }
      this.top = -(newTop / this.moveStep)
      this.topPercentage = this.top / this.moveRange
    },
    scroll: function (deltaY) {
      const minTop = -this.moveRange
      let newTop = this.top + deltaY
      if (newTop > maxTop) {
        newTop = maxTop
      }
      if (newTop < minTop) {
        newTop = minTop
      }
      this.top = newTop
      this.topPercentage = this.top / this.moveRange
      this.$emit('scroll', (this.top - 10))
    },
    scrollByWheel: function (event) {
      if (this.show) {
        const deltaY = (event.deltaY > 0) ? (-this.mouseMoveRange) : this.mouseMoveRange
        this.scroll(deltaY)
      }
      event.preventDefault()
      // event.stopPropagation()
    }
  },
  computed: {
    scrollTop: function () {
      return this.top * -1
    },
    scrollContetnTop: function () {
      return this.top * this.moveStep
    }
  },
  watch: {
    top: function (value) {
      this.$emit('topChanged')
    }
  }
}
</script>
<style lang="scss">
//need to finish: press and disable
.icon-button {
  padding: 0;
  border: 0px;
  background-color: transparent;
  &:focus{
    outline: 0;
  }
}
.scrollContainer {
  position: relative; //for Scrollbar component
  overflow: hidden; // disable default scrollbar
  &.scrolling {
    user-select: none; //IE is not working on scrolling. Maybe we can use a overlay to avoid that.
  }
  >.scroll-content {
    // z-index: 1;
    // padding-right: 15px;
  }
  >.scrollbar {
    height: 100%;
    position: absolute;
    right: 2px;
    display: flex;
    flex-direction: column;
    z-index: 2;
    >.scroll-area {
      flex: 1;
      width: 8px;
      position: relative;
      >.scroll {
        width: 8px;
        background-color: #c0c0c0;
        border-radius: 4px;
        min-height: 20px;
        position: absolute;
        cursor: default;
        &:hover,
        &:active {
          background-color: #9b9b9b;
          border: 1px #898989 solid;
        }
      }
    }
    >.up {
      width: 12px;
      height: 12px;
      background-image: url("../assets/scrollbar/w_up_normal.png");
      cursor: pointer;
      &:hover {
        background-image: url("../assets/scrollbar/w_up_over.png");
      }
      &:active {
        background-image: url("../assets/scrollbar/w_up_press.png");
      }
      &:disabled {
        background-image: url("../assets/scrollbar/w_up_disable.png");
      }
    }
    >.down {
      width: 12px;
      height: 12px;
      background-image: url("../assets/scrollbar/w_down_normal.png");
      cursor: pointer;
      &:hover {
        background-image: url("../assets/scrollbar/w_down_over.png");
      }
      &:active {
        background-image: url("../assets/scrollbar/w_down_press.png");
      }
      &:disabled {
        background-image: url("../assets/scrollbar/w_down_disable.png");
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Scrollbar.vue